import { Button, Card, Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { AccountSnapshotTable } from '@components/Reports/AccountSnapshot/AccountSnapshotTable';
import { Page500 } from '@containers/ErrorPages';
import { reportsApi } from '@reducers/reports/reports';

export const Snapshot = () => {
  const { data, isLoading, isError } = reportsApi.useGetAccountSnapshotQuery();
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Header className="bg-didxl text-white text-center">
            Account Snapshot
          </Card.Header>
          <Card.Body>
            <AccountSnapshotTable data={data} />
            <Button variant="didxl" size="sm">
              Export to CSV
            </Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
